import React, { Fragment } from "react"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar/index"
import SuperAdminParent from "../../components/Billing/SuperAdmin/SuperAdminParent/index"
import { MuiThemeProvider } from "@material-ui/core/styles"
import billingTheme from "../../themes/billing"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { SuperTableContainer } from "./SuperTableContext"

const MyBilling = props => {
  // Blocking billing page access to non AD/Master users
  // let isAd = false
  // props.authentication.authenticatedUser.companies.map(company => {
  //   if (company.name === "Master" || company.name === "Assignment Desk") {
  //     company.managers.map(manager => {
  //       if (manager.id === props.authentication.authenticatedUser.id) {
  //         isAd = true
  //       }
  //     })
  //   }
  // })
  // if (isAd == false) {
  //   props.history.push(`/crew`)
  // }
  // Blocking billing page for anyone besides: Courtney, Erin, Dustin, Hollis, and Robbie
  // 10/16: Adding Marianne
  //   if (
  //     props.authentication.authenticatedUser.id === 1607 ||
  //     props.authentication.authenticatedUser.id === 1611 ||
  //     props.authentication.authenticatedUser.id === 170163 ||
  //     props.authentication.authenticatedUser.id === 166152 ||
  //     props.authentication.authenticatedUser.id === 166521 ||
  //     props.authentication.authenticatedUser.id === 173842 ||
  //     props.authentication.authenticatedUser.id === 169704 ||
  //     props.authentication.authenticatedUser.id === 170293 ||
  //     props.authentication.authenticatedUser.id === 90589 ||
  //     props.authentication.authenticatedUser.id === 173919
  //   ) {
  //     console.log("user is allowed to view villing tab")
  //   } else {
  //     props.history.push(`/crew`)
  //   }
  return (
    <Fragment>
      {/* <CrewMamaAppBarComponent history={props.history} />
      <MuiThemeProvider theme={billingTheme}>
        <SuperTableContainer {...props}>
          <SuperAdminParent history={props.history} />
        </SuperTableContainer>
      </MuiThemeProvider> */}
      <CrewMamaAppBarComponent history={props.history} />
      {/* <iframe
        src="https://staging-new-site.crewmama.com/crew-billing"
        style={{ height: "100vh", width: "100vw" }}
        title="Iframe Example"
        allow="clipboard-read; clipboard-write"
      /> */}
      <iframe
        src="https://new-site.crewmama.com/crew-billing"
        style={{ height: "100vh", width: "100vw" }}
        title="Iframe Example"
        allow="clipboard-read; clipboard-write"
      />
    </Fragment>
  )
}

// const mapStateToProps = state => {
//   return {
//     authenticatedUser: state.authentication.authenticatedUser,
//     activeCompany: state.companies.activeCompany,
//     userData: state.billing.generalData,
//     // Wrong below that's ALL users
//     // users: state.misc.users,
//     roles: state.misc.roles,
//     users: state.billing.usersRolesArray,
//     crew: state.crew,
//   }
// }

// const connector = connect(mapStateToProps)
// (connector(Billing))
export default withRouter(MyBilling)
